import { axios as request } from '@/utils/request.js'
import api from './api'
import user from './user'
import order from './order'
import find from './find'
import ceping from './ceping'

export { 
    request, 
    api,
    user,
    order,
    find,
    ceping
}